module.exports = __webpack_public_path__ + "img/wifi-shopping-mall.446012fc.webp";